
var $ = window.$ = window.jQuery = require("jquery"),
	_ = window._ = require("lodash");

require("./extend/jquery")($);
require("../less/style.less");



// WEBPACK FOOTER //
// ./src/js/bundle.js